module.exports = __webpack_public_path__ + "img/sort.a08ea17f.svg";